import { render, staticRenderFns } from "./is-widget.vue?vue&type=template&id=7a25828c"
import script from "./is-widget.vue?vue&type=script&lang=js"
export * from "./is-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports